import React, {Fragment, ReactNode, useEffect} from 'react';
import * as serviceWorkerRegistration from 'serviceWorkerRegistration';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/scss/main.scss';
import 'scss/components/updater.scss';
import {__} from 'js/tool/page/current';

type IProps = {
	children: ReactNode
}

function UpdateLayer({children}: IProps) {
	useEffect(() => {
		if (import.meta.env.REACT_APP_ENVIRONMENT !== 'dev') {
			serviceWorkerRegistration.register({
				onUpdate: function (serviceWorkerRegistration: ServiceWorkerRegistration) {
					const currRegistrationWaiting = serviceWorkerRegistration.waiting;

					if (currRegistrationWaiting) {
						currRegistrationWaiting.postMessage({type: 'SKIP_WAITING'});

						toast(
							<div className="update-test">
								<span><i className="fas fa-sync"/></span>
								{__('fb:new version')}
							</div>
						);
					}
				},
			});
		} else {
			serviceWorkerRegistration.unregister();
		}
	}, []);

	function onUserConfirmUpdate() {
		window.location.reload();
	}

	return (
		<Fragment>
			<ToastContainer
				position="bottom-left"
				autoClose={false}
				closeButton={false}
				closeOnClick={false}
				draggable={false}
				limit={1}
				onClick={onUserConfirmUpdate}
			/>
			{children}
		</Fragment>
	);
}

export default UpdateLayer;
